// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { CtsGantryStepStatusEType } from '../../enum/cts-gantry-step-status-type';

@Component({
  standalone: true,
  imports: [CommonModule, TranslateModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  selector: 'app-cts-gantry-functional-unit-grid-legend',
  templateUrl: './cts-gantry-functional-unit-grid-legend.component.html',
  styleUrl: './cts-gantry-functional-unit-grid-legend.component.scss',
})
export class CtsGantryFunctionalUnitGridLegendComponent {
  protected readonly legends = [
    {
      id: 'grid-legend-notExecuted',
      classModifier: CtsGantryStepStatusEType.NOT_EXECUTED,
      label: 'cts.gantry.grid.legend.notExecuted',
    },
    {
      id: 'grid-legend-executed',
      classModifier: CtsGantryStepStatusEType.EXECUTED,
      label: 'cts.gantry.grid.legend.executed',
    },
    {
      id: 'grid-legend-failed',
      classModifier: CtsGantryStepStatusEType.FAILED,
      label: 'cts.gantry.grid.legend.failed',
    },
    {
      id: 'grid-legend-successful',
      classModifier: CtsGantryStepStatusEType.SUCCESSFUL,
      label: 'cts.gantry.grid.legend.successful',
    },
  ];
}
